import React, { useEffect, useState } from "react";
import Footer from "../components/Footer";
import axios from "axios";
import KeyboardArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardArrowLeftOutlined";
import { useNavigate } from "react-router-dom";

// Cấu hình axios bên ngoài component
axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("user");
        if (token) {
            config.headers["Authorization"] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

function CSKH() {
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    const [setting, setSetting] = useState(JSON.parse(localStorage.getItem("setting")));
    const navigate = useNavigate();

    const handleBackClick = () => {
        navigate(-1);
    };

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/setting/get`, {}).then((res) => {
            if (JSON.stringify(setting) !== JSON.stringify(res.data.data[0])) {
                setSetting(res.data.data[0]);
                localStorage.setItem("setting", JSON.stringify(res.data.data[0]));
            }
        });
        axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {})
            .then((res) => {
                if (JSON.stringify(profile) !== JSON.stringify(res.data.data)) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                }
            })
            .catch((err) => localStorage.removeItem("user"));
    }, []);

    return (
        <>
            <style>{`
                /* Giữ nguyên các class cũ của bạn và chỉ ghi đè style nút */
                .cskh-container-new {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 15px;
                    padding-top: 40px;
                }
                .btn-service-new {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 90%;
                    max-width: 350px;
                    height: 50px;
                    border-radius: 8px;
                    text-decoration: none;
                    font-weight: 600;
                    font-size: 16px;
                    color: white !important;
                    transition: all 0.2s ease;
                    text-transform: uppercase;
                    letter-spacing: 1px;
                    border: none;
                }
                /* Màu sắc gradient cho nút 1 */
                .btn-color-1 {
                    background: linear-gradient(135deg, #1e90ff 0%, #0052d4 100%);
                    box-shadow: 0 4px 15px rgba(30, 144, 255, 0.4);
                }
                /* Màu sắc gradient cho nút 2 */
                .btn-color-2 {
                    background: linear-gradient(135deg, #4b6cb7 0%, #182848 100%);
                    box-shadow: 0 4px 15px rgba(24, 40, 72, 0.4);
                }
                .btn-service-new:active {
                    transform: scale(0.96);
                    opacity: 0.9;
                }
            `}</style>

            <div className="title-top">
                <div className="back" onClick={handleBackClick}>
                    <KeyboardArrowLeftOutlinedIcon />
                </div>
                <h1 className="title-h1">CSKH</h1>
            </div>

            <div className="main">
                <img
                    src={require("../../img/CSKH-cover-blue@2x.7365166c.png")}
                    style={{ 
                        display: "block", 
                        margin: "0 -0.6rem", 
                        width: "calc(100% + 1.2rem)", 
                        maxWidth: "calc(100% + 1.2rem)" 
                    }}
                    alt="Banner"
                />
                
                {/* Giữ nguyên style container 70vh của bạn */}
                <div style={{ position: "relative", height: "70vh" }} className="cskh-container-new">
                    
                    {setting?.cskh && (
                        <a href={setting.cskh} target="_blank" rel="noreferrer" className="btn-service-new btn-color-1">
                            CSKH TRỰC TUYẾN 1
                        </a>
                    )}

                    {setting?.cskh2 && setting?.cskh2 !== "" && (
                        <a href={setting.cskh2} target="_blank" rel="noreferrer" className="btn-service-new btn-color-2">
                            CSKH TRỰC TUYẾN 2
                        </a>
                    )}

                </div>
            </div>
            <Footer />
        </>
    );
}

export default CSKH;